import React from 'react';
import SectionIcon from './SectionIcon';
import { AVOID_CONDITIONS } from 'app/services/api/fake_services/menu_management_fake_data';

export default function NotesSection({ values, setFieldValue, readonly = false }) {
  const toggleAvoidCondition = (condition) => {
    const current = values.avoidConditions;
    const updated = current.includes(condition) ? current.filter((c) => c !== condition) : [...current, condition];
    setFieldValue('avoidConditions', updated);
  };

  const selectedAvoidConditions = AVOID_CONDITIONS.filter((condition) => {
    return values.avoidConditions.includes(condition.id);
  });

  return (
    <div className="px-4 py-8 border-b border-slate-50">
      <SectionIcon title="注意・配慮事項">
        <span className="material-symbols-outlined text-primary text-xl">warning</span>
      </SectionIcon>

      <div className="space-y-6">
        <div>
          <p className="text-sm font-bold mb-3">施術を避けたい条件</p>
          <div className="grid grid-cols-2 gap-3">
            {!readonly ? (
              <>
                {AVOID_CONDITIONS.map((condition) => (
                  <label
                    key={condition.id}
                    className="flex items-center gap-3 p-3 border border-slate-100 rounded-xl bg-slate-50/50"
                  >
                    <input
                      type="checkbox"
                      checked={values.avoidConditions.includes(condition.id)}
                      onChange={() => toggleAvoidCondition(condition.id)}
                      className="w-5 h-5 rounded border-slate-300 text-blue-btn-primary"
                    />
                    <span className="text-sm font-medium">{condition.label}</span>
                  </label>
                ))}
              </>
            ) : selectedAvoidConditions.length === 0 ? (
              <p>なし</p>
            ) : (
              <>
                {selectedAvoidConditions.map((condition) => (
                  <label
                    key={condition.id}
                    className="flex items-center gap-3 p-3 border border-slate-100 rounded-xl bg-slate-50/50"
                  >
                    <input
                      type="checkbox"
                      checked={values.avoidConditions.includes(condition.id)}
                      readOnly
                      className="w-5 h-5 rounded border-slate-300 text-blue-btn-primary"
                    />
                    <span className="text-sm font-medium">{condition.label}</span>
                  </label>
                ))}
              </>
            )}
          </div>
        </div>

        <label className="block">
          <p className="text-sm font-bold mb-2">お客様への注意事項</p>
          {!readonly ? (
            <textarea
              name="customerNotes"
              value={values.customerNotes || ''}
              onChange={(e) => setFieldValue('customerNotes', e.target.value)}
              placeholder="例：カラー直後の施術は色落ちの可能性があります。"
              className="w-full rounded-xl border border-slate-200 focus:outline-none focus:ring-blue-btn-primary/20 focus:border-blue-btn-primary min-h-[96px] p-4 text-sm"
            />
          ) : (
            <p className="whitespace-pre-line">{values.customerNotes || 'なし'}</p>
          )}
        </label>
      </div>
    </div>
  );
}
